module.exports = __webpack_public_path__ + "static/media/AS.e6a6d2f8.png";